import React from "react"
import ControlButton from "./ControlButton"
import { VolumeDown16, VolumeMute16, VolumeUp16 } from "@carbon/icons-react"

const SwitchedVolumeIcon = ({ volume }) => {
  if (volume < 0.5) {
    return <VolumeDown16 className="w-5" />
  } else {
    return <VolumeUp16 className="ml-[0.125rem] w-5" />
  }
}

const ControlVideoVolume = ({
  className,
  volume,
  setVolume,
  muted,
  setMuted,
}) => {
  const handleVolumeChange = (e) => {
    setVolume(parseFloat(e.target.value))
  }

  return (
    <div className={`${className} flex group transition-colors duration-300`}>
      <ControlButton
        onClick={() => setMuted(!muted)}
        className="group-hover:bg-gray-850 group-hover:border-gray-850"
      >
        {muted ? (
          <VolumeMute16 className="w-5" />
        ) : (
          <>
            <SwitchedVolumeIcon volume={volume} />
          </>
        )}
      </ControlButton>
      <div className="relative flex items-center justify-center w-0 h-12 overflow-hidden transition-all duration-300 group-hover:w-20 group-hover:bg-gray-850 group-hover:pr-4">
        <input
          className="h-4 w-16 block cursor-pointer appearance-none rounded-md bg-transparent [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:bg-transparent [&::-webkit-slider-thumb]:w-1 [&::-webkit-slider-thumb]:h-1 [&::-moz-range-progress]:appearance-none [&::-moz-range-progress]:bg-transparent [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:bg-transparent [&::-moz-range-thumb]:border-none [&::-moz-range-thumb]:w-1 [&::-moz-range-thumb]:h-1"
          type="range"
          min={0}
          max={1}
          step="any"
          value={volume}
          onChange={handleVolumeChange}
        />
        <div className="absolute block w-16 h-1 bg-gray-500 pointer-events-none">
          <progress
            className={`h-1 w-16 appearance-none absolute bg-transparent [&::-webkit-progress-bar]:h-1 [&::-webkit-progress-value]:h-1 [&::-webkit-progress-bar]:bg-transparent [&::-webkit-progress-value]:bg-gray-50 [&::-moz-progress-bar]:bg-gray-50`}
            max="1"
            step="any"
            value={volume}
          ></progress>
        </div>
      </div>
    </div>
  )
}

export default ControlVideoVolume
